import SimpleLightbox from 'simple-lightbox';

const initLightbox = () => {
  // eslint-disable-next-line no-new
  new SimpleLightbox({ elements: '.js-gallery .js-gallery__item' });
};

export default initLightbox;



// WEBPACK FOOTER //
// ./scripts/modules/lightbox.js